/* Mango Basket product page (Oct 2026). Loaded only by sections/mango-preorder.liquid. Homepage hero clicks are tracked here too. */
(function () {
  'use strict';

  /* one helper for the custom events: Shopify customer events (for pixels) and Klaviyo. No new pixel is loaded. */
  function track(name, data, state) {
    data = data || {}; if (state) data.state = state;
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('mango_basket_' + name, data); } catch (e) {}
    try { var q = window.klaviyo || (window._learnq = window._learnq || []); q.push(['track', 'Mango Basket ' + name.replace(/_/g, ' '), data]); } catch (e) {}
  }

  /* homepage hero */
  var heroLinks = document.querySelectorAll('[data-mh-link]');
  for (var h = 0; h < heroLinks.length; h++) {
    (function (a) { a.addEventListener('click', function () { track('homepage_hero_click', { target: a.getAttribute('data-mh-link') }, a.getAttribute('data-mh-state')); }); })(heroLinks[h]);
  }

  var root = document.querySelector('main.mb'); if (!root) return;
  var dock = document.getElementById('DiscoDock'); if (dock) dock.classList.add('mb-hide');
  var STATE = root.getAttribute('data-state');
  var VID = parseInt(root.getAttribute('data-variant'), 10);
  var PID = parseInt(root.getAttribute('data-product'), 10);
  var KL_KEY = root.getAttribute('data-kl-key'), KL_LIST = root.getAttribute('data-kl-list'), KL_SMS_LIST = root.getAttribute('data-kl-sms');
  var MSG_PICK = root.getAttribute('data-pick-error') || 'Choose shipping or pickup first.';

  var form = document.getElementById('MangoForm');
  var err = root.querySelector('[data-mb-err]');
  var mixed = root.querySelector('[data-mb-mixed]');
  var pick = root.querySelector('[data-mb-pick]');
  var express = root.querySelector('[data-mb-express]');
  var btns = document.querySelectorAll('[data-mb-reserve]');
  var busy = false;

  function setBusy(on) {
    busy = on;
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i];
      if (on) { if (!b.getAttribute('data-label')) b.setAttribute('data-label', b.textContent); b.textContent = 'One moment…'; b.disabled = true; }
      else { if (b.getAttribute('data-label')) b.textContent = b.getAttribute('data-label'); b.disabled = false; }
    }
  }
  function getCart() { return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
  function mangoLine(cart) { var f = null; if (cart && cart.items) cart.items.forEach(function (i) { if (i.product_id === PID && !f) f = i; }); return f; }
  function hasOthers(cart) { return !!(cart && cart.items && cart.items.some(function (i) { return i.product_id !== PID; })); }
  function chosen() { return pick ? pick.querySelector('input:checked') : null; }
  function props() {
    var p = {}, c = chosen();
    if (c) p['Fulfillment'] = c.value;
    var note = form && form.querySelector('input[name="properties[Preorder]"]');
    if (note && note.value) p['Preorder'] = note.value;
    return p;
  }
  function post(url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (r.ok) return true; return r.json().then(function (j) { throw { soldout: r.status === 422, msg: j && (j.description || j.message) }; }); });
  }

  if (pick) pick.addEventListener('change', function () {
    var c = chosen(); if (!c) return;
    pick.classList.remove('mb-need');
    if (err) err.textContent = '';
    if (express) express.removeAttribute('inert');
    track('fulfillment_selected', { method: c.getAttribute('data-mb-choice') }, STATE);
  });

  /* One bottle per tap. Asks for shipping or pickup first. If a bottle is already in the cart it is not added again,
     only its shipping/pickup choice is updated. Whatever else is in the cart stays and comes along to checkout. */
  function reserve(source) {
    if (busy) return;
    track('preorder_cta_click', { source: source }, STATE);
    if (!chosen()) {
      if (pick) { pick.classList.add('mb-need'); pick.scrollIntoView({ block: 'center' }); var first = pick.querySelector('input'); if (first) first.focus({ preventScroll: true }); }
      if (err) err.textContent = MSG_PICK;
      return;
    }
    setBusy(true);
    if (err) err.textContent = '';
    getCart().then(function (cart) {
      var line = mangoLine(cart);
      if (line) return post('/cart/change.js', { id: line.key, quantity: line.quantity, properties: props() });
      return post('/cart/add.js', { items: [{ id: VID, quantity: 1, properties: props() }] });
    }).then(function () {
      window.location.href = '/checkout';
    }).catch(function (e) {
      setBusy(false);
      /* the last bottle went while this page was open: reload so the page shows the reserved state */
      if (e && e.soldout) { window.location.reload(); }
      else if (form) { form.submit(); }
    });
  }
  for (var i = 0; i < btns.length; i++) {
    (function (b) { b.addEventListener('click', function (e) { e.preventDefault(); reserve(b.hasAttribute('data-mb-main') ? 'page' : 'sticky_bar'); }); })(btns[i]);
  }
  window.addEventListener('pageshow', function () { setBusy(false); });
  if (mixed) getCart().then(function (c) { if (hasOthers(c)) mixed.classList.add('on'); }).catch(function () {});

  var bags = document.querySelectorAll('[data-mb-bag]');
  for (var b2 = 0; b2 < bags.length; b2++) bags[b2].addEventListener('click', function () { track('add_to_bag_click', {}, STATE); });
  var laters = document.querySelectorAll('[data-mb-later]');
  for (var l2 = 0; l2 < laters.length; l2++) laters[l2].addEventListener('click', function () { track('waitlist_link_click', {}, STATE); });

  /* November list: Klaviyo's client subscribe endpoint, the same one the old first-smell page used. */
  var list = root.querySelector('[data-mb-list]');
  if (list) {
    var lf = list.querySelector('form'), lerr = list.querySelector('[data-mb-lerr]'), join = list.querySelector('[data-mb-join]');
    var sub = function (listId, attrs) {
      return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KL_KEY, { method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: 'Mango Basket product page', profile: { data: { type: 'profile', attributes: attrs } } }, relationships: { list: { data: { type: 'list', id: listId } } } } }) })
        .then(function (r) { return r.status === 202 || r.ok; });
    };
    var normPhone = function (v) { var d = (v || '').replace(/[^\d+]/g, ''); if (d.indexOf('+') === 0) return d; d = d.replace(/\D/g, ''); if (d.length === 10) return '+1' + d; if (d.length === 11 && d.charAt(0) === '1') return '+' + d; return null; };
    /* One field, one tap. The first-name field is hidden, the phone number sits behind a small "Text me too" link,
       and a mango inside the email field ripens as the address is typed. Styles are injected here. */
    (function () {
      var em = document.getElementById('mbEmail'), fn = document.getElementById('mbFirst'), ph = document.getElementById('mbPhone');
      if (!em) return;
      var st2 = document.createElement('style');
      st2.textContent = '.mb-list .mb-off{display:none!important}' +
        '.mb-ripe{position:relative;display:block;margin:0 0 6px}' +
        '.mb-list .mb-ripe input[type=email]{margin:0;padding-right:58px}' +
        '.mb-ripe i{position:absolute;right:14px;top:50%;width:30px;height:28px;margin-top:-14px;pointer-events:none;transition:transform .35s cubic-bezier(.3,1.5,.5,1),filter .35s ease}' +
        '.mb-ripe.ripe i{animation:mbRipe .7s ease 1}' +
        '@keyframes mbRipe{0%{transform:scale(1) rotate(0)}35%{transform:scale(1.3) rotate(-14deg)}70%{transform:scale(.95) rotate(8deg)}100%{transform:scale(1) rotate(0)}}' +
        '.mb-ripe-say{display:block;font-family:var(--font-display);font-style:italic;font-size:16px;line-height:1.3;margin:0 0 14px;opacity:.85}' +
        '.mb-list .mb-more{display:inline-block;background:none;border:0;padding:6px 0;margin:10px 0 0;font:inherit;font-size:15px;color:inherit;text-decoration:underline;text-underline-offset:3px;cursor:pointer;opacity:.85}' +
        '.mb-list.done .mb-list-done::before{content:"";display:inline-block;width:30px;height:28px;margin-right:10px;vertical-align:-6px;background:var(--mb-art) center / contain no-repeat;animation:mbDrop .7s cubic-bezier(.3,1.5,.5,1) 1}' +
        '@keyframes mbDrop{0%{transform:translateY(-34px) rotate(-30deg);opacity:0}100%{transform:none;opacity:1}}' +
        '@media (prefers-reduced-motion:reduce){.mb-ripe i{transition:none}.mb-ripe.ripe i,.mb-list.done .mb-list-done::before{animation:none}}';
      document.head.appendChild(st2);
      /* borrow the mango artwork from the stylesheet so the image has one home */
      var probe = document.createElement('div'); probe.className = 'mb-left'; probe.style.display = 'none';
      probe.innerHTML = '<span class="mb-left-dots"><i></i></span>'; root.appendChild(probe);
      var art2 = getComputedStyle(probe.querySelector('i')).backgroundImage; root.removeChild(probe);
      list.style.setProperty('--mb-art', art2);
      if (fn) { fn.classList.add('mb-off'); fn.required = false; var fl = lf.querySelector('label[for="mbFirst"]'); if (fl) fl.classList.add('mb-off'); }
      var el2 = lf.querySelector('label[for="mbEmail"]'); if (el2) el2.classList.add('mb-off');
      em.setAttribute('aria-label', 'Email address'); em.placeholder = 'Your email';
      var wrap = document.createElement('span'); wrap.className = 'mb-ripe';
      em.parentNode.insertBefore(wrap, em); wrap.appendChild(em);
      var m = document.createElement('i'); m.setAttribute('aria-hidden', 'true'); m.style.background = art2 + ' center / contain no-repeat'; wrap.appendChild(m);
      var say = document.createElement('span'); say.className = 'mb-ripe-say'; say.setAttribute('aria-live', 'polite'); say.textContent = 'It ripens as you type.';
      wrap.parentNode.insertBefore(say, wrap.nextSibling);
      var ok = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
      var ripen = function () {
        var v = (em.value || '').trim(), full = ok.test(v), p = full ? 1 : Math.min(0.8, v.length / 20);
        m.style.filter = 'grayscale(' + (0.8 * (1 - p)).toFixed(2) + ') hue-rotate(' + Math.round(60 * (1 - p)) + 'deg) brightness(' + (0.72 + 0.28 * p).toFixed(2) + ')';
        if (!full) m.style.transform = 'scale(' + (0.62 + 0.38 * p).toFixed(2) + ') rotate(' + Math.round(-24 * (1 - p)) + 'deg)'; else m.style.transform = '';
        if (full !== wrap.classList.contains('ripe')) { wrap.classList.toggle('ripe', full); say.textContent = full ? 'Ripe. Send it.' : 'It ripens as you type.'; if (full) join.classList.add('mb-go'); else join.classList.remove('mb-go'); }
      };
      em.addEventListener('input', ripen); ripen();
      if (ph) {
        var bits = [lf.querySelector('label[for="mbPhone"]'), ph, lf.querySelector('.mb-sms')];
        for (var q2 = 0; q2 < bits.length; q2++) if (bits[q2]) bits[q2].classList.add('mb-off');
        var more = document.createElement('button'); more.type = 'button'; more.className = 'mb-more'; more.textContent = 'Text me too';
        more.addEventListener('click', function () { for (var q3 = 0; q3 < bits.length; q3++) if (bits[q3]) bits[q3].classList.remove('mb-off'); more.classList.add('mb-off'); ph.focus(); });
        lf.appendChild(more);
      }
    })();
    lf.addEventListener('submit', function (e) {
      e.preventDefault();
      var firstEl = document.getElementById('mbFirst'), emailEl = document.getElementById('mbEmail');
      var phoneEl = document.getElementById('mbPhone'), smsEl = document.getElementById('mbSms');
      var first = (firstEl.value || '').trim(), email = (emailEl.value || '').trim();
      var phoneRaw = phoneEl ? (phoneEl.value || '').trim() : '', sms = !!(smsEl && smsEl.checked);
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { lerr.textContent = 'That email address looks incomplete.'; emailEl.focus(); return; }
      var phone = null;
      if (phoneRaw) { phone = normPhone(phoneRaw); if (!phone) { lerr.textContent = 'A 10-digit US mobile number works best, or leave it blank.'; phoneEl.focus(); return; } }
      lerr.textContent = ''; join.disabled = true; var label = join.textContent; join.textContent = 'One moment…';
      var extra = { 'Source': 'Mango Basket product page', 'Campaign': 'Mango Basket launch', 'Intent': 'November ready-to-ship release' };
      /* Klaviyo's client endpoint takes consent from the list subscription itself; a 'subscriptions' block inside the profile is rejected. */
      var who = { email: email, properties: extra };
      if (first) who.first_name = first;
      sub(KL_LIST, who).then(function (ok) {
        if (!ok) throw 0;
        /* a phone number on its own never subscribes anyone to texts: the box has to be ticked too */
        if (phone && sms && KL_SMS_LIST) return sub(KL_SMS_LIST, { email: email, phone_number: phone, properties: extra });
      }).then(function () {
        list.classList.add('done');
        track('waitlist_signup', { sms: !!(phone && sms) }, STATE);
      }).catch(function () { join.disabled = false; join.textContent = label; lerr.textContent = 'That did not go through. Please try once more.'; });
    });
  }

  /* sticky bar on phones: after the main action has scrolled away, hidden again at the list form and the footer */
  var sticky = document.querySelector('[data-mb-sticky]');
  var main = root.querySelector('[data-mb-main]') || root.querySelector('[data-mb-join]');
  if (sticky && main && 'IntersectionObserver' in window) {
    var mainVisible = true, footVisible = false, listVisible = false;
    var sb = sticky.querySelector('button, a');
    var paint = function () {
      var on = !mainVisible && !footVisible && !listVisible;
      sticky.classList.toggle('on', on);
      sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (sb) sb.tabIndex = on ? 0 : -1;
    };
    new IntersectionObserver(function (en) { mainVisible = en[0].isIntersecting || en[0].boundingClientRect.top > 0; paint(); }).observe(main);
    var foot = document.querySelector('footer.ftr');
    if (foot) new IntersectionObserver(function (en) { footVisible = en[0].isIntersecting; paint(); }).observe(foot);
    if (list && STATE === 'preorder') new IntersectionObserver(function (en) { listVisible = en[0].isIntersecting; paint(); }).observe(list);
  }

  /* Interactive tracker. The row of mangoes ripples so it reads as alive; tapping a mango lifts it out of the row and into a
     "yours" slot under the tracker, the main button becomes "Reserve my bottle", and the page moves to the ship-or-pickup choice.
     It is a visual claim only: nothing is reserved until payment. Styles are injected here so the section stays untouched. */
  var box = root.querySelector('[data-mb-left]');
  if (box && pick) {
    var css = '.mb-left{cursor:pointer;-webkit-tap-highlight-color:transparent;transition:background .2s ease}' +
      '.mb-left:hover{background:rgba(194,161,77,.24)}' +
      '.mb-left:focus-visible{outline:2px solid var(--cream);outline-offset:3px}' +
      '.mb .mb-left-dots i{transition:transform .2s ease;animation:mbWave 5.5s ease-in-out infinite}' +
      '.mb .mb-left-dots i:hover{animation:none;transform:translateY(-3px) scale(1.55)}' +
      '.mb .mb-left.picked .mb-left-dots i{animation:none}' +
      '.mb .mb-left.picked .mb-left-dots i:last-child{visibility:hidden}' +
      '@keyframes mbWave{0%,10%,100%{transform:translateY(0) scale(1)}5%{transform:translateY(-5px) scale(1.25)}}' +
      '.mb-left-hint{display:flex;align-items:center;gap:11px;font-size:14.5px;line-height:1.35;color:#e4c8b2;margin:-6px 0 18px}' +
      '.mb-left-slot{flex:none;position:relative;width:54px;height:48px;color:rgba(244,232,204,.6);transition:color .3s ease}' +
      '.mb-left-slot svg{position:absolute;left:0;top:0;width:100%;height:100%;overflow:visible}' +
      '.mb-left-slot b{position:absolute;left:12px;top:3px;width:30px;height:28px;opacity:0;transform:translateY(-16px) rotate(-30deg) scale(0);transition:transform .45s cubic-bezier(.3,1.6,.5,1),opacity .2s ease}' +
      '.mb-left-hint.got{color:var(--gold)}' +
      '.mb-left-hint.got .mb-left-slot{color:var(--gold)}' +
      '.mb-left-hint.got .mb-left-slot b{opacity:1;transform:rotate(-14deg) scale(1)}' +
      '.mb-fly{position:fixed;z-index:9999;pointer-events:none;transition:transform .5s cubic-bezier(.4,0,.2,1);will-change:transform}' +
      '.mb-stage .btn-primary.mb-go{animation:mbGo 1.1s ease 1}' +
      '@keyframes mbGo{0%{box-shadow:0 0 0 0 rgba(255,214,120,.8)}100%{box-shadow:0 0 0 16px rgba(255,214,120,0)}}' +
      '@media (prefers-reduced-motion:reduce){.mb .mb-left-dots i{animation:none}.mb-fly{transition:none}}';
    for (var w = 1; w <= 30; w++) css += '.mb .mb-left-dots i:nth-child(' + w + '){animation-delay:' + (w * 80) + 'ms}';
    var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

    var firstMango = box.querySelector('.mb-left-dots i');
    var art = firstMango ? getComputedStyle(firstMango).backgroundImage : 'none';
    var hint = document.createElement('p');
    hint.className = 'mb-left-hint';
    /* the basket: handle behind, mango in the middle, woven front on top so the fruit sits inside it */
    var bg = '', up = box.parentNode; while (up && up.nodeType === 1 && !bg) { var c0 = getComputedStyle(up).backgroundColor; if (c0 && c0 !== 'rgba(0, 0, 0, 0)' && c0 !== 'transparent') bg = c0; up = up.parentNode; } if (!bg) bg = '#471d15';
    hint.innerHTML = '<span class="mb-left-slot" aria-hidden="true">' +
      '<svg viewBox="0 0 54 48" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"><path d="M11 21C11 3 43 3 43 21"/></svg><b></b>' +
      '<svg viewBox="0 0 54 48" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M6 23L11 43.5Q11.6 45.5 14 45.5H40Q42.4 45.5 43 43.5L48 23Z" fill="' + bg + '"/><path d="M4 21.5H50" stroke-width="2.6"/><path d="M7.6 29.5Q27 32.6 46.4 29.5M9.3 36.8Q27 39.6 44.7 36.8" stroke-width="1" opacity=".75"/><path d="M15 23.5L17.6 45M23 24L24 45.5M31 24L30 45.5M39 23.5L36.4 45" stroke-width="1" opacity=".75"/></svg>' +
      '</span><span data-mb-hint>Pick a mango for your basket.</span>';
    hint.querySelector('b').style.background = art + ' center / contain no-repeat';
    box.parentNode.insertBefore(hint, box.nextSibling);
    var hintText = hint.querySelector('[data-mb-hint]'), slot = hint.querySelector('.mb-left-slot');
    box.setAttribute('role', 'button');
    box.setAttribute('tabindex', '0');
    box.setAttribute('aria-label', box.getAttribute('data-mb-left') + ' bottles left. Pick one, then choose shipping or pickup.');
    var mainBtn = root.querySelector('[data-mb-main]');

    var claim = function (from, scroll) {
      if (!box.classList.contains('picked')) {
        var src = from || box.querySelector('.mb-left-dots i:last-child');
        var done = function () {
          hint.classList.add('got');
          hintText.textContent = 'This one is yours. Now choose shipping or pickup.';
        };
        if (src && src.getBoundingClientRect && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          var a = src.getBoundingClientRect(), z = slot.getBoundingClientRect();
          var fly = document.createElement('div');
          fly.className = 'mb-fly';
          fly.style.cssText = 'left:' + a.left + 'px;top:' + a.top + 'px;width:' + a.width + 'px;height:' + a.height + 'px;background:' + art + ' center / contain no-repeat';
          document.body.appendChild(fly);
          void fly.offsetWidth;
          fly.style.transform = 'translate(' + (z.left + z.width / 2 - a.left - a.width / 2) + 'px,' + (z.top + 17 - a.top - a.height / 2) + 'px) scale(1.55)';
          setTimeout(function () { if (fly.parentNode) fly.parentNode.removeChild(fly); done(); }, 520);
        } else { done(); }
        box.classList.add('picked');
        if (mainBtn && !busy) {
          var price = (mainBtn.textContent.match(/·\s*\$\d+/) || [''])[0];
          mainBtn.textContent = 'Reserve my bottle' + (price ? ' ' + price : '');
          mainBtn.classList.add('mb-go');
        }
        try { if (navigator.vibrate) navigator.vibrate(12); } catch (e) {}
        track('tracker_claim', {}, STATE);
      }
      if (scroll) {
        setTimeout(function () {
          /* bring the choices and the button into view while keeping the tracker on screen where the phone is tall enough */
          var target = mainBtn || pick;
          target.style.scrollMarginBottom = '28px';
          target.scrollIntoView({ block: 'end', behavior: 'smooth' });
          if (!chosen()) { var r = pick.querySelector('input'); if (r) r.focus({ preventScroll: true }); }
        }, 560);
      }
    };
    box.addEventListener('click', function (e) { claim(e.target && e.target.tagName === 'I' && e.target.parentNode.classList.contains('mb-left-dots') ? e.target : null, true); });
    box.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); claim(null, true); } });
    pick.addEventListener('change', function () { claim(null, false); });
  }

  /* gallery: native swipe, plus Previous / Next on desktop */
  var gal = root.querySelector('[data-mb-gal]');
  if (gal) {
    var trackEl = gal.querySelector('.mb-track'), slides = gal.querySelectorAll('.mb-slide');
    var prev = gal.querySelector('[data-mb-prev]'), next = gal.querySelector('[data-mb-next]');
    var idx = 0;
    var current = function () {
      var mid = trackEl.scrollLeft + trackEl.clientWidth / 2, best = 0, bd = Infinity;
      for (var k = 0; k < slides.length; k++) { var c = slides[k].offsetLeft - trackEl.offsetLeft + slides[k].offsetWidth / 2; var d = Math.abs(c - mid); if (d < bd) { bd = d; best = k; } }
      return best;
    };
    var sync = function () { idx = current(); if (prev) prev.disabled = idx === 0; if (next) next.disabled = idx === slides.length - 1; };
    var go = function (k) { k = Math.max(0, Math.min(slides.length - 1, k)); var sl = slides[k]; trackEl.scrollTo({ left: sl.offsetLeft - trackEl.offsetLeft - (trackEl.clientWidth - sl.offsetWidth) / 2, behavior: 'smooth' }); };
    if (prev) prev.addEventListener('click', function () { go(idx - 1); });
    if (next) next.addEventListener('click', function () { go(idx + 1); });
    var t; trackEl.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(sync, 80); }, { passive: true });
    trackEl.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1); } if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1); } });
    sync();
  }
})();
